import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Icon } from 'semantic-ui-react';

import { localSet } from '../../utils/localStorage';

class OrganisationSelector extends Component {
  static propTypes = {
    isSidebarExtended: PropTypes.bool.isRequired,
    organisations: PropTypes.shape({
      byId: PropTypes.shape({}).isRequired,
      allIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
    currentOrganisation: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.changeOrganisation = this.changeOrganisation.bind(this);
  }

  changeOrganisation(e, { value }) {
    localSet('organisation', value);
    window.location.reload();
  }

  render() {
    const { isSidebarExtended, organisations, currentOrganisation } = this.props;
    const selectedId = organisations.byId[currentOrganisation].id;
    const options = organisations.allIds.map(id => ({
      key: id,
      value: id,
      disabled: id === selectedId,
      text: organisations.byId[id].name,
    }));
    return (
      <div className="navlink-container">
        <div className="navlink-container-left" />
        <div className="navlink-container-center">
          <div className="icon-group-left">
            <Icon
              name="globe"
              size="large"
              className={isSidebarExtended ? 'sidebar-icon-extended' : 'sidebar-icon-collapsed'}
            />
          </div>
          <div className="icon-group-right">
            <Dropdown
              value={selectedId}
              defaultOpen={false}
              options={options}
              onChange={this.changeOrganisation}
            />
          </div>
        </div>
        <div className="navlink-container-right" />
      </div>
    );
  }
}

export default OrganisationSelector;



// WEBPACK FOOTER //
// ./src/components/OrganisationSelector/OrganisationSelector.js